import React from 'react';
import s from './TimeTravel.scss';
var TimeTravel = function () {
    return React.createElement("div", { className: s['root'] }, "Time Travel is active");
};
TimeTravel.displayName = 'TimeTravel';
export default TimeTravel;
//# sourceMappingURL=TimeTravel.js.map